if (window.self != window.top) {
  // 被嵌入时执行的代码
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (target && target.tagName.toLowerCase() === 'a') {
        let href = event.target.getAttribute('href');
        // 发送消息到外层页面
        postOpenHref(href);
      }
    },
    false
  );
  window.originalWindowOpen = window.open;
  // 重写window.open函数
  window.open = function (url, windowName, windowFeatures) {
    postOpenHref(url);
    // 然后你可以调用原始的window.open函数
    return window.originalWindowOpen(url, windowName, windowFeatures);
  };
}

export const postOpenHref = url => {
  if (window.self != window.top) {
    if (url && /^(http|https):\/\/[^ "]+$/.test(url)) {
      var message = {
        type: 'openHref',
        data: url
      };
      console.log('openHref', message);
      window.top.postMessage(message, '*');
    }
  }
};
